import { render } from "./ArchivedUsers.vue?vue&type=template&id=6b40e6dc"
import script from "./ArchivedUsers.vue?vue&type=script&lang=js"
export * from "./ArchivedUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__